<template>
  <!-- ***** About ESG Start ***** -->
  <div class="about">
    <section class="section" id="about">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <div class="center-heading">
              <h2><em>About</em></h2>
              <p>
                For over a decade, The Edge has continued to evaluate and
                recognise top performing companies and their continuous pursuit
                of growth opportunities while ensuring a right balance between
                profits and best business practices. Environmental, Social and
                Governance principles are crucial to developing strong,
                resilient companies that can deliver long-term values to
                investors, stakeholders and the communities they serve.
              </p>
              <p>
                This year, The Edge’s inaugural ESG Awards 2022 will set out to
                recognise those that have truly adopted the mantra of ‘business
                for good’ and have made positive contribution to the business,
                society and the environment through successful ESG practices.
              </p>
              <p>
                As proven by consistent and rising demand amongst investors,
                stakeholders and communities for the adoption and evaluation of
                ESG practices, The Edge ESG Awards aim to:
              </p>
              <ul>
                <li>
                  Promote ESG adoption amongst Malaysian companies by
                  recognising their contributions and successes in adopting good
                  ESG practices
                </li>
                <li>
                  Encourage ESG leadership amongst industry leaders and
                  professionals in delivering positive impact for their
                  business, society and the environment
                </li>
              </ul>
              <p>
                The award is automatic for all companies listed on Bursa
                Malaysia as at March 31, 2022 and no entries are required.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- ***** About ESG End ***** -->
</template>

<script>
export default {};
</script>

<style></style>
